module.exports = __webpack_public_path__ + "img/intro_uk.33dec460.svg";